import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
    font-family: 'Geist';
    font-feature-settings: 'ss01' on, 'ss03' on, 'ss05' on, 'liga' off, 'clig' off;
  }

  code,
  pre,
  kbd,
  samp,
  tt {
    font-family: 'Geist Mono', monospace;
  }

  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-y: hidden;
  }

  #root {
    width: 100vw;
    height: 100vh;
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
  }

  *:hover {
    scrollbar-color: #D4D4D4 transparent;
  }

`;

export default GlobalStyle;
